<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-31 11:46:20
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-08 10:07:42
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-27 09:56:12
-->
<template>
  <div id="box" class="box">
    <div id="left" :style="{height:`${heightLeft}px`}" class="left">
      <div style="font-weight:600;" class="title">组织机构</div>
      <div class="search">
        <a-input-search
          v-model:value="value"
          placeholder="搜索组织名称"
          size="large"
        >
          <template #enterButton>
            <img @click="search" class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
       <a-spin :spinning="treeLoading">
      <div class="ant-tree">
        <a-tree
          ref="tree"
          :style="{height:`${heightLeft-100}px`,overflowY:'auto',overflowX:'hidden'}"
          show-line
          :tree-data="treeData"
          v-if="treeData.length > 0"
          @select="onSelect"
          :auto-expand-parent="isCloseAll"
          :defaultExpandedKeys="defaultExpandedKeys"
          :selectedKeys="checkedKeys"
          :expanded-keys="expandedKeys"
          :default-expanded-keys="columnOpenIds"
          @expand="onExpand"
        >
          <template  slot-scope="text" slot="child">
               <a-icon   class="icon-box-img"  type="link" />
           </template>
  	     
        </a-tree>
      </div>
      </a-spin>
    </div>
     <div id="resize" :style="{height:`${heightLeft}px`}"></div>
    <div id="right" class="right">
      <div class="right-title-box">
           <div style="font-weight: 600;" class="right-name">报备统计-{{ organizationName }}</div>
      </div>
      <div class="right-flex">
        <div class="search">
           <el-button
                type="primary"
                @click="daoChuFn"
                v-if="codeData.indexOf('424') != -1"
                >导出统计</el-button
                >
                <div>
                     <el-date-picker
                        v-model="valueTwo"
                        type="daterange"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                      </el-date-picker>
            <el-button class="search-box" type="primary"  @click="listSearch"
          ></span>查询</el-button
        >
                </div>
        </div>
      </div>
        <div class="table-box" :style="{height:`${height}px`}">
            <div class="box-one">
               <coententTable
              @onShowSizeChange="onShowSizeChange"
              :columns="columns"
              :dataSource="dataSource"
              :bordered='true'
              :loading="loading"
              :customSlot="customSlot"
              @handleSizeChange="handleSizeChange"
              sortId='key'
            >
            <template v-slot:operation="scopeVal"></template>
            </coententTable>
            </div>
            <div class="box-two">
               <coententTable
              @onShowSizeChange="onShowSizeChange"
              :columns="columnsTwo"
              :dataSource="dataSourceTwo"
              :bordered='true'
              :customSlot="customSlot"
               :loading="loading"
              @handleSizeChange="handleSizeChange"
            >
            <template v-slot:operation="scopeVal"></template>
            </coententTable>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {
  tree,
  findReportingAdministrativeStatistics,
  findReportingStatistics,
  applyReportStatisticsExport,
} from "../index";
export default {
  data() {
    return {
      value:'',
      valueTwo:[],
      height: 0,
      heightLeft: 0,
      isCloseAll: false,
      checkedSiteIdTwo: [],
      selectedKeys: [],
      treeData: [],
      resData: [],
      timeTwo: [],
      pickerOptions: {
          shortcuts: [{
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近180天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      columns: [
        {
          title: "",
          dataIndex: "name",
          width: 150,
          ellipsis: true,
          colSpan: 2,
          customRender: (value, row, index) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if (index == 0) {
              obj.attrs.colSpan = 2;
            }

            if (index == 1) {
              obj.attrs.colSpan = 2;
            }
            if (index == 2) {
              obj.attrs.rowSpan = 9;
            }
            if (index == 11) {
              obj.attrs.rowSpan = 4;
            }
            if (index == 15) {
              obj.attrs.rowSpan = 6;
            }
            if (index == 21) {
              obj.attrs.rowSpan = 4;
            }
            if (index == 25) {
              obj.attrs.colSpan = 2;
            }
            if (index == 26) {
              obj.attrs.colSpan = 2;
            }
            return obj;
          },
        },
        {
          title: "zz",
          dataIndex: "zzzzzzz",
          width: 300,
          colSpan: 0,
        },
        {
          title: "申请人情况",
          dataIndex: "shengq",
          ellipsis: true,
          colSpan: 2,
          children: [
            {
              title: "自然人",
              dataIndex: "naturalPersonSum",
              width: 10,
              colSpan: 2,
            },
            {
              title: "法人或其他组织",
              dataIndex: "qita",
              width: 100,
              children: [
                {
                  title: "商业企业",
                  dataIndex: "merchandisingEnterpriseSum",
                  width: 100,
                },
                {
                  title: "科研机构",
                  dataIndex: "scientificEstablishmentSum",
                  width: 100,
                },
                {
                  title: "社会公益组织",
                  dataIndex: "socialBenefitSum",
                  width: 150,
                },
                {
                  title: "法律服务机构",
                  dataIndex: "lawOfficesSum",
                  width: 150,
                },
                {
                  title: "其他",
                  dataIndex: "otherSum",
                  width: 150,
                },
              ],
            },
            {
              title: "总计",
              dataIndex: "sum",
              colSpan: 2,
              customRender: (value, row, index) => {
              const obj = {
                children: value,
                attrs: {},
              };
               obj.attrs.colSpan = 4;
              return obj;
            },
            },
             
          ],
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      organizationId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "adoptType",
          customRender: "adoptType",
        },
        {
          name: "titleTwo",
          customRender: "titleTwo",
        },
      ],
      organizationName: "",
      dataType: 0,
      loading: false,
      time: "",
      dataSourceTwo:[],
      columnsTwo:[
        {
          title: "行政复议",
          dataIndex: "generatedAdministrativeReviewPendingTrial",
          ellipsis: true,
          children: [
            {
              title: "结果维持",
              dataIndex: "generatedAdministrativeReviewResultMaintenance",
              width: 100,
            },
            {
              title: "结果纠正",
              dataIndex: "generatedAdministrativeReviewResultCorrection",
              width: 100,
            },
             {
              title: "其他结果",
              dataIndex: "generatedAdministrativeReviewOtherResults",
              width: 100,
            },
             {
              title: "尚未审结",
              dataIndex: "generatedAdministrativeReviewPendingTrial",
              width: 100,
            },
             {
              title: "总计",
              dataIndex: "administrativeReviewSum",
              width: 100,
            },
          ],
        },
         {
          title: "行政诉讼",
          dataIndex: "su",
          ellipsis: true,
          children: [
            {
              title: "未经复议直接起诉",
              dataIndex: "song",
              width: 100,
              children: [
                  {
                    title: "结果维持",
                    dataIndex: "notReviewedProsecuteResultMaintenance",
                    width: 100,
                  },
                  {
                    title: "结果纠正",
                    dataIndex: "notReviewedProsecuteResultCorrection",
                    width: 100,
                  },
                  {
                    title: "其他结果",
                    dataIndex: "notReviewedProsecuteOtherResults",
                    width: 100,
                  },
                  {
                    title: "尚未审结",
                    dataIndex: "notReviewedProsecutePendingTrial",
                    width: 100,
                  },
                  {
                    title: "总计",
                    dataIndex: "notAdministrativeProceedingSum",
                    width: 100,
                  },
                ],
            },
           {
              title: "复议后起诉",
              dataIndex: "fusu",
              width: 100,
              children: [
                  {
                    title: "结果维持",
                    dataIndex: "ReviewedProsecuteResultMaintenance",
                    width: 100,
                  },
                  {
                    title: "结果纠正",
                    dataIndex: "ReviewedProsecuteResultCorrection",
                    width: 100,
                  },
                  {
                    title: "其他结果",
                    dataIndex: "ReviewedProsecuteOtherResults",
                    width: 100,
                  },
                  {
                    title: "尚未审结",
                    dataIndex: "ReviewedProsecutePendingTrial",
                    width: 100,
                  },
                  {
                    title: "总计",
                    dataIndex: "AdministrativeProceedingSum",
                    width: 100,
                  },
                ],
            },
          ],
        },
      ],
      selectDatas: [],
      checkedKeys: [],
      codeData: [],
      columnOpenIds: [],
      defaultExpandedKeys: [],
      treeLoading: false,
      oldThreeData: [],
      expandedKeys: [],
      
    };
  },
  components: {
    coententTable,
  },
  watch: {
    value(val) {
      this.treeData = this.oldThreeData;
      this.search();
    },
  },
  mounted() {
    this.getThreeList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 200}`;
    this.getLeftMove();
    let startDate = new Date();
    let endDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    this.valueTwo = [startDate,endDate];
    this.height = document.documentElement.clientHeight - 300;
  },
  methods: {
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.isCloseAll = false;
    },
    filterTree(arr, keyword, first = true) {
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key);
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
            this.expandedKeys.push(item.key);
          }
        }
      }
      return emptyArr;
    },
    daoChuFn(){
        let startTime = "";
        let endTime = "";
        if (this.valueTwo.length > 0) {
          startTime = this.farmatDate(
            new Date(this.valueTwo[0].toString()).getTime(),
            "-"
          );
          endTime = this.farmatDate(
            new Date(this.valueTwo[1].toString()).getTime(),
            "-"
          );
        }
        applyReportStatisticsExport({
          organizationId:this.organizationId,
          startTime,
          endTime,
          fileName:'报备统计清单',
        }).then((res)=>{

        })
    },
    getLeftMove() {
      var resize = document.getElementById("resize");
      var left = document.getElementById("left");
      var right = document.getElementById("right");
      var box = document.getElementById("box");
      resize.onmousedown = function (e) {
        var startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          var endX = e.clientX;

          var moveLen = resize.left + (endX - startX);
          var maxT = box.clientWidth - resize.offsetWidth;
          if (moveLen < 250) moveLen = 250;
          if (moveLen > 600) moveLen = 600;
          if (moveLen > maxT - 150) moveLen = maxT - 150;

          resize.style.left = moveLen;
          left.style.width = moveLen + "px";
          right.style.width = box.clientWidth - moveLen - 5 + "px";
        };
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture();
        };
        resize.setCapture && resize.setCapture();
        return false;
      };
    },
    search() {
      if(!this.value){
          this.expandedKeys = [this.treeData[0].key];
          return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.value);
      this.isCloseAll = true;
    },
    handleMenuClick(e) {
     
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
      this.getListTwo();
    },
    onShowSizeChange(current) {
     
    },
    handleSizeChange(page, pageSize) {
      
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    getList() {
      let startTime = "";
      let endTime = "";
      if (this.valueTwo.length > 0) {
        startTime = this.farmatDate(
          new Date(this.valueTwo[0].toString()).getTime(),
          "-"
        );
        endTime = this.farmatDate(
          new Date(this.valueTwo[1].toString()).getTime(),
          "-"
        );
      }
      findReportingAdministrativeStatistics({
        organizationId:this.organizationId,
        startTime,
        endTime,
      }).then((res)=>{
        if(res.code == 0){
            this.dataSourceTwo = [res.data];
        }
          
      })
       
    },
    getListTwo(){
        this.loading = true;
      let startTime = "";
      let endTime = "";
      if (this.valueTwo.length > 0) {
        startTime = this.farmatDate(
          new Date(this.valueTwo[0].toString()).getTime(),
          "-"
        );
        endTime = this.farmatDate(
          new Date(this.valueTwo[1].toString()).getTime(),
          "-"
        );
      }
      findReportingStatistics({
        organizationId:this.organizationId,
        startTime,
        endTime,
      }).then((res)=>{
        if(res.code == 0){
            this.dataSource = res.data;
            this.loading = false;
        }
          
      })
    },
    getThreeList() {
      const _this = this;
      this.treeLoading = true;
       this.loading = true;
      tree({
        columnName: this.value,
        siteId: sessionStorage.getItem("siteId"),
        orgIds: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        if (res.code == 0) {
          this.resData = res.data;
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "key");
          _this.treeData = JSON.parse(options);
          _this.oldThreeData = _this.treeData;
          _this.organizationId = _this.treeData[0].key;
          _this.checkedKeys = [_this.treeData[0].key];
          _this.expandedKeys = [_this.treeData[0].key];
          _this.organizationName = _this.treeData[0].title;
          this.treeLoading = false;
          this.getList();
          this.getListTwo();
        }
      });
    },
    onSelect(key, event) {
      if (key.length == 0) {
        return;
      }
      this.organizationId = key[0];
      this.organizationName = event.node._props.title;
      this.checkedKeys = [this.organizationId];
      this.getList();
      this.getListTwo();
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  height: 100%;
  width: 100%;
  //position: relative;
  .left {
    width: 250px;
    font-size: 14px;
    border-right: solid 1px #f2f3f5;
    color: #000;
    padding: 24px;
    padding-top: 0px;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    .ant-tree {
      min-height: 300px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
    /deep/ .ant-btn-primary {
      color: #fff !important;
      background-color: #1890ff !important;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: #000;
    width: 500px;
    .right-name {
      padding-left: 24px;
    }
    .search {
      display: flex;
      margin-right: 24px;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .el-date-editor .el-range-input{
          background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
    }
  }
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.right-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-left: 17px;
  flex-wrap: wrap;
  .search {
    margin-left: 6px !important;
  }
  /deep/ .ant-btn,
  .ant-dropdown-trigger {
    height: 40px;
    background: #ecf5ff;
    color: #18abff;
    border-color: #c9e3ff;
    text-align: center;
  }
  /deep/ .ant-dropdown-menu-item {
    text-align: center;
  }
  /deep/ .ant-dropdown-trigger {
    border-radius: 3px;
    background-color: rgba(240, 246, 255, 1) !important;
    text-align: center;
    border: 1px solid rgba(23, 109, 230, 1) !important;
    color: rgba(23, 109, 230, 1) !important;
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
  width: 300px;
}

.table-th {
  width: 126px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table-tn {
  width: 60px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table_one {
  border: solid 1px #ccc;
  width: 100%;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 101px;
  border-radius: 5px;
}
.sort-box {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-box-two {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-two {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.sort-style {
  width: 43px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  flex: 1;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 1px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 529px);
  padding-right: 24px;
  bottom: 0px;
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.zhi-ding {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(237, 109, 103, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(237, 109, 103, 0.3);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 66px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
.tui-song {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(24, 109, 230, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(24, 109, 230, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.icon-box-img {
  cursor: pointer;
}
#resize {
  width: 5px;
  height: 100%;
  cursor: w-resize;
  float: left;
}
.right-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  cursor: pointer;
  .right-title-box-txt {
    color: rgba(102, 111, 128, 1);
    font-size: 14px;
    text-align: right;
    font-family: Roboto-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    height: 406px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 13px;
  }
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
}
.choose-column-box {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .table {
  margin-top: 0px;
}
.search-box {
  // position: absolute;
  // right: 24px;
  margin-left: 10px;
}
/deep/ .ant-tree.ant-tree-show-line li:not(:last-child)::before {
  border-left: 1px dashed rgba(187, 187, 187, 1);
}
.title-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
  color: rgba(24, 109, 230, 1);
}
.tips-box {
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    font-family: Roboto-black;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
}
.title-adoptin {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.score-box {
  max-height: 256px;
  min-height: 100px;
  margin-top: 14px !important;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /deep/ .el-checkbox__label {
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input {
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
}
/deep/ .el-checkbox:last-of-type {
  margin-right: 30px;
}
/deep/ .ant-table{
  border: none;
}
.box .search {
  padding: 0px !important;
}
.box-two{
     /deep/ .ant-table-tbody > tr > td {
      text-align: center;
    }
    /deep/ .ant-table-thead > tr > th{
        text-align: center;
    }
}
.box-one{
  /deep/ .ant-table-tbody > tr:first-child > td {
  text-align: center;
}
/deep/ .ant-table-tbody > tr:nth-child(2) > td {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:last-child {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:nth-last-child(2) {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:nth-last-child(3) {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:nth-last-child(4) {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:nth-last-child(5) {
  text-align: center;
}
/deep/ .ant-table-tbody > tr > td:nth-last-child(6) {
  text-align: center;
}
/deep/ .ant-table-thead > tr > th{
  text-align: center;
}
/deep/ .ant-table-tbody > tr:nth-child(27) > td {
  text-align: center;
}
/deep/ .ant-table-tbody > tr:nth-child(26) > td {
  text-align: center;
}

/deep/ .ant-table-tbody > tr:nth-child(3) > td:not(:first-child) {
   display: none !important;
}
/deep/ .ant-table-tbody > tr:nth-child(12) > td:not(:first-child) {
   display: none !important;
}
/deep/ .ant-table-tbody > tr:nth-child(16) > td:not(:first-child) {
   display: none !important;
}
/deep/ .ant-table-tbody > tr:nth-child(22) > td:not(:first-child) {
   display: none !important;
}
// /deep/ .ant-table-tbody > tr > td:last-child {
//    display: none !important;
// }
/deep/ .ant-table-tbody > tr > td:nth-child(2) {
   border-right: none;
   padding-left: 0px !important;
}
/deep/ .ant-table-tbody > tr > td:nth-child(3) {
   padding-left: 0px !important;
   text-align: center;
   
}
}
/deep/.el-date-editor .el-range-separator{
  width: 10% !important;
}
.table-box{
  overflow-y: auto;
}

</style>